import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { setOrder } from 'src/app/click-it/orders/cement/order-cement-state/order-cement-action';
import { setCart, setrotationCart } from '../cement-state/cement.action';
import { GoogleEventsService } from 'src/app/shared/analyticservice/google-events.service';
import { ClickItService } from 'src/app/click-it/services/click-it.service';
import moment from 'moment';
import { DashboardService } from 'src/app/click-it/dashboard/services/dashboard.service';
import {
  businessDetails,
  dashboardDetails,
  userDetails,
} from 'src/app/auth/state/auth.actions';
import { Subject, debounceTime } from 'rxjs';

@Component({
  selector: 'app-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: [
    './success-modal.component.scss',
    './success-modal.component.rtl.scss',
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SuccessModalComponent implements OnInit {
  @Output() cancelModal = new EventEmitter();
  @Output() newOrder = new EventEmitter();
  @Input() rotation: any;
  userDetails: any;
  cartData: any;
  rotationCartData: any;
  countryLogo: string | undefined;
  orderData: any;
  rotationOrderData: any;
  stars = [
    { isDark: false },
    { isDark: false },
    { isDark: false },
    { isDark: false },
    { isDark: false },
  ];
  surveyDetails: any;
  selectedOption: string = '';
  feedback: string = '';
  filteredSurveyData: any;
  isRatingVisible: boolean = false;
  showRating: boolean = true;
  showButtonTrack: boolean = true;
  showButtonSurvey: boolean = false;
  spinnerLoader: boolean = false;
  isfeedback: boolean = false;
  isShowLogo: boolean = true;
  businessData: any;
  private readonly debounceTimeMs = 300;
  private destroy$ = new Subject<void>();
  private searchQuerySubject = new Subject<string>();
  authData: any;
  constructor(
    private router: Router,
    private store: Store,
    private analyticService: GoogleEventsService,
    public translate: TranslateService,
    private dashService: DashboardService,
    private clickItService: ClickItService
  ) {
    this.countryLogo = '/assets/images/country-logo/clickit.svg';
  }

  ngOnInit(): void {
    this.store
      .select((state) => state)
      .subscribe((data: any) => {
        this.authData = data?.authReducer;
        this.userDetails = data?.authReducer?.userDetails;
        this.businessData = data.authReducer.businessDetails;
        this.cartData = data.cartReducer.cartData;
        this.rotationCartData = data.cartReducer.rotationCartData;
        this.orderData = data.orderReducer.orderData;
        this.rotationOrderData = data.orderReducer.rotationOrderData;
        this.surveyDetails = data.authReducer.dashboardDetails;
      });
    if (this.surveyDetails?.enabled_surveys) {
      this.surveyLogic();
    }
    this.searchQuerySubject
      .pipe(debounceTime(500))
      .subscribe((searchQuery: string) => {
        this.commentEvent(searchQuery);
      });
    this.contryLogoLogic();
  }
  contryLogoLogic() {
    if (this.userDetails?.country?.locale === 'en-GB') {
      this.countryLogo = '/assets/images/country-logo/clickit-by-ai-uk.svg';
    } else if (
      this.userDetails?.country?.locale === 'ar-EG' ||
      this.userDetails?.country?.locale === 'en-EG'
    ) {
      this.countryLogo =
        '/assets/images/country-logo/clickit-by-lafarge-egypt.svg';
    } else if (
      this.userDetails?.country?.locale === 'en-KE' ||
      this.userDetails?.country?.locale === 'sw-KE' ||
      this.userDetails?.country?.locale === 'fr-KE'
    ) {
      this.countryLogo =
        '/assets/images/country-logo/clickit-by-bamburi-kenya.svg';
    } else if (
      this.userDetails?.country?.locale === 'en-NG' ||
      this.userDetails?.country?.locale === 'en-ZA'
    ) {
      this.countryLogo =
        '/assets/images/country-logo/clickit-by-lafarge-nigeria.svg';
    } else if (this.userDetails?.country?.locale === 'en-PH') {
      this.countryLogo = '/assets/images/country-logo/clickit-by-holcim-ph.svg';
    } else if (
      this.userDetails?.country?.locale === 'en-UG' ||
      this.userDetails?.country?.locale === 'sw-UG' ||
      this.userDetails?.country?.locale === 'ar-UG' ||
      this.userDetails?.country?.locale === 'fr-UG'
    ) {
      this.countryLogo =
        '/assets/images/country-logo/clickit-by-hima-uganda.svg';
    } else if (this.userDetails?.country?.locale === 'fr-FR') {
      this.countryLogo = '/assets/images/country-logo/header-ng.svg';
    } 
    else if (this.userDetails?.country?.locale === 'en-GR'){
      this.countryLogo = '/assets/images/country-logo/clickit-by-heracles-greece.jpg';
    } else {
      this.countryLogo = '/assets/images/country-logo/clickit.svg';
    }
  }

  naviagateToProductCatalogue() {
    this.onClickCloseModal();
    this.router.navigateByUrl('/more/product-catalogue');
  }

  onClickCloseModal() {
    if (this.rotation == 'rotation') {
      let updatedRotationCartData = {
        ...this.rotationCartData,
        products: [],
        deliveryDetails: {},
        scheduleOrderData: [],
        scheduleProduct: [],
      };
      this.store.dispatch(
        setrotationCart({
          data: updatedRotationCartData,
        })
      );
      let updatedRotationOrderData = {
        ...this.rotationOrderData,
        orderList: [],
      };
      this.store.dispatch(
        setOrder({
          data: updatedRotationOrderData,
        })
      );

      this.router.navigateByUrl('orders/rotation-cement');
    } else {
      this.clickItService.removeCoupon();
      let updatedCartData = {
        ...this.cartData,
        products: [],
        scheduleOrderData: [],
        scheduleProduct: [],
        deliveryDetails: {},
        discount_Details: {},
        couponValue: false,
      };
      this.store.dispatch(
        setCart({
          data: updatedCartData,
        })
      );
      let updatedOrderData = {
        ...this.orderData,
        orderList: [],
      };
      this.store.dispatch(
        setOrder({
          data: updatedOrderData,
        })
      );
      if (this.cartData?.isAggregateTab) {
        this.router.navigateByUrl('orders/aggregate');

      } else if (this.cartData?.isAsphaltTab) {
        this.router.navigateByUrl('orders/asphalt');

      } else if (!this.cartData?.isAggregateTab && !this.cartData?.isAsphaltTab) {
        this.router.navigateByUrl('orders/cement');
      } else {
        this.router.navigateByUrl('orders/cement');
      }
    }
    this.cancelModal.emit(null);
    this.trackOrderClickEvent();
  }

  onClickNewOrder() {
    this.newOrder.emit(true);
    this.newOrderClickEvent();
  }
  // <---------------- Google-Analytics Strats -------------->
  newOrderClickEvent() {
    let action = 'NewOrderClicked';
    let category = 'Core Purchasing Activity';
    let label = 'Click NewOrderOnOrderConfSuccess';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  trackOrderClickEvent() {
    let action = 'TrackOrderClicked';
    let category = 'Core Purchasing Activity';
    let label = 'Click TrackOrderOnOrderConfSucces';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  CloseOrderConfClicked() {
    let action = 'CloseOrderConfClicked';
    let category = 'Core Purchasing Activity';
    let label = 'Click CloseOrderConfSuccess';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  onSkipClickedEvent() {
    let action = 'ClickOnSkip';
    let category = 'Survey Activity';
    let label = 'Click SkipButton';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  onNextClickedEvent() {
    let action = 'ClickOnNext';
    let category = 'Survey Activity';
    let label = 'Click NextButton';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  commentEvent(data: any) {
    let action = 'OnComment';
    let category = 'Survey Activity';
    let label = 'Click Comment';
    let index = '';
    let value = data;
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  clickYesEvent(data: any) {
    let action = 'ClickOnYes';
    let category = 'Survey Activity';
    let label = 'Click YesButton';
    let index = '';
    let value = data;
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  clickNoEvent(data: any) {
    let action = 'ClickOnNo';
    let category = 'Survey Activity';
    let label = 'Click NoButton';
    let index = '';
    let value = data;
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  clickOnStarEvent(data: any) {
    let action = 'ClickOnRatingStar';
    let category = 'Survey Activity';
    let label = 'Click RatingStar';
    let index = '';
    let value = data;
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  // <---------------- Google-Analytics ends -------------->
  /// survey code //////////////
  surveyLogic() {
    this.filteredSurveyData = this.surveyDetails?.enabled_surveys?.find(
      (e) =>
        e.target_feature === 'ORDER_CREATION' &&
        moment(new Date(), 'HH:mm').isBetween(
          moment(e.start_time, 'HH:mm'),
          moment(e.end_time, 'HH:mm')
        )
    );
    if (this.filteredSurveyData) {
      this.isRatingVisible = true;
      this.showButtonTrack = false;
      this.showButtonSurvey = true;
    } else {
      this.isRatingVisible = false;
      this.showButtonTrack = true;
      this.showButtonSurvey = false;
    }
  }
  selectedStarCount = 0;
  toggleStar(index: number): void {
    for (let i = 0; i <= index; i++) {
      this.stars[i].isDark = true;
    }
    for (let i = index + 1; i < this.stars.length; i++) {
      this.stars[i].isDark = false;
    }
    this.selectedStarCount = index + 1;
    this.clickOnStarEvent(this.selectedStarCount);
  }
  onSelectionChange() {
    console.log('Selected option:', this.selectedOption);
    if (this.selectedOption === 'Yes') {
      this.clickYesEvent(this.selectedOption);
    } else {
      this.clickNoEvent(this.selectedOption);
    }
  }
  onSubmit() {
    this.spinnerLoader = true;
    const body = {
      survey_id: this.filteredSurveyData?.id,
      survey_comment: this.feedback,
    };
    if (this.filteredSurveyData?.survey_type == 'rating') {
      body['rating'] = this.selectedStarCount;
    } else {
      body['survey_answer'] = this.selectedOption;
    }
    console.log(body, 'body');
    this.dashService.surveyApi(body).subscribe((res) => {
      console.log(res);
      if (res) {
        this.spinnerLoader = false;
        this.isfeedback = true;
        this.isRatingVisible = false;
        this.isShowLogo = false;
        this.showButtonTrack = true;
        this.showButtonSurvey = false;
        setTimeout(() => {
          this.getDashBoardDetails();
        }, 1000);
      }
    });
    this.onNextClickedEvent();
  }
  onValueChange(value: string): void {
    this.feedback = value;
    this.searchQuerySubject.next(value);
  }
  onCancel() {
    this.spinnerLoader = true;
    const body = {
      survey_id: this.filteredSurveyData?.id,
      rating: '',
      survey_comment: '',
    };
    console.log(body, 'body');
    this.dashService.surveyApi(body).subscribe((res) => {
      console.log(res);
      if (res) {
        this.isRatingVisible = false;
        this.showButtonTrack = true;
        this.isShowLogo = true;
        this.showButtonSurvey = false;
        this.spinnerLoader = false;
        setTimeout(() => {
          this.getDashBoardDetails();
        }, 1000);
      }
    });
    this.onSkipClickedEvent();
  }
  getDashBoardDetails() {
    this.dashService.dashboardDetails().subscribe({
      next: (res) => {
        let updatedData = {
          ...this.userDetails,
          settings_data: res?.settings_data,
          menus: res?.menu_settings,
        };

        let updateBusinessData = {
          ...this.businessData,
          settings_data: res?.settings_data,
          menu_settings: res?.menu_settings,
        };

        this.store.dispatch(
          userDetails({
            data: updatedData,
          })
        );
        this.store.dispatch(
          businessDetails({
            data: updateBusinessData,
          })
        );
        this.store.dispatch(
          dashboardDetails({
            dashboardDetails: res,
          })
        );
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
}
